/*
 * @Descripttion: create file
 * @Author: zhangtingjiang
 * @Date: 2020-11-18 09:31:47
 */
import instance from './http.config.js'

export const postMaterial = (activityId, materialTypeId, params) => instance.post(`/v2/player/activities/${activityId}/requirements/${materialTypeId}/upload_material`, params)

export const putMaterial = (activityId, materialTypeId, fileId, params) => instance.put(`/v2/player/activities/${activityId}/requirements/${materialTypeId}/upload_material/${fileId}`, params)

export const postMaterialV3 = (activityId, materialTypeId, params) => instance.post(`/v3/player/activities/${activityId}/requirements/${materialTypeId}/upload_material`, params)

export const putMaterialV3 = (activityId, materialTypeId, fileId, params) => instance.put(`/v3/player/activities/${activityId}/requirements/${materialTypeId}/upload_material/${fileId}`, params)



// WEBPACK FOOTER //
// ./src/service/uploadFile.js